function loadNews(url, renderItem) {
  return $.getJSON(url).then(response => render(response, renderItem));
}

function render(response, renderItem) {
  const { articles } = response;
  if (articles && articles.length) {
    const items = articles.map(article => renderItem(renderArticle(article)));
    return items.join('');
  }
  return '';
}

function renderArticle(article) {
  return `
    <a href="${article.url}" class="news-card">
      <figure class="news-card__figure">
        <div class="news-card__image-wrapper">
          ${renderImage(article)}
        </div>
        <figcaption class="news-card__info">
          <em class="news-card__type">${article.type}</em>
          <h4 class="news-card__title">${article.headline}</h4>
          <span class="news-card__date">${article.dateFormatted}</span>
        </figcaption>
      </figure>
    </a>
  `;
}

function renderImage(article) {
  if (article.imageUrl) {
    return /*HTML*/ `
        <img data-src="${article.imageUrl}"
          alt="${article.headline}"
          class="news-card__image lazyload"
          />
      `;
  }
  return '';
}

export default loadNews;
